import { Record } from 'immutable';
export default Record({
  id: undefined,
  firstName: undefined,
  lastName: undefined,
  email: undefined,
  avatarUri: undefined
}, 'HubUser');